import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

// 自由切换当前模块是否使用mock
// const mock = false

export default class Tags {
  // 动态获取表头
  static async getDynamicTableHeaders(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/type-dynamic-table-list-headers?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 动态获取列表数据
  static async getDynamicTableResult(payload, type) {
    if (!type) {
      const [err, res] = await To(
        wizStandardInstance.post('/api/std/StdClassData/type-dynamic-table-paged-result', payload)
      )
      return Callback(err, res)
    }
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/StdClassData/dynamic-table-paged-result-advance-query',
        payload
      )
    )
    return Callback(err, res)
  }
  // 根据id获取单条数据
  static async getDynamicTableById(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/type-dynamic-table-data-by-id?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 查询已发布的实体列表
  static async publishedClassList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/published-class-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async find(payload) {
    // const instance = mock ? mockInstance : apiInstance
    const [err, res] = await To(
      wizStandardInstance.get(`/api/basedata/tag?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async exportFilterTag(payload) {
    // const instance = mock ? mockInstance : apiInstance
    const [err, res] = await To(
      wizStandardInstance.post('/api/Tag/ExportFilterTagInfoToFile', payload)
    )
    return Callback(err, res)
  }
  static async findDownloadProgress(payload) {
    // const instance = mock ? mockInstance : apiInstance
    const [err, res] = await To(
      wizStandardInstance.get(`/api/tag/query_progress_bar/${payload.id}`)
    )
    return Callback(err, res)
  }
  static async findNewDownloadProgress(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/share/common/query_progress_bar/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 获取位号树及下级数据
  static async getTagTree(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/directory_expansion', payload)
    )
    return Callback(err, res)
  }
  // 获取位号树及下级数据
  static async getDirectoryExpansionV2(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/directory_expansion_v2', payload)
    )
    return Callback(err, res)
  }
  // 获取位号树展开节点
  static async getTagNodeChildByTag(payload, standardId) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/Document/tag-expansion?tagParentId=${payload.businessId}&standardId=${standardId}`
      )
    )
    return Callback(err, res)
  }
  static async getTagFilterNull(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/tag/handover/fliter_null?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取设备缺陷列表
  static async getDeviceDefectList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/defect_management/page?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增设备缺陷
  static async addDeviceDefect(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/defect_management/add', payload))
    return Callback(err, res)
  }
  // 编辑设备缺陷
  static async editDeviceDefect(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/defect_management/modify', payload))
    return Callback(err, res)
  }
  // 删除设备缺陷
  static async deleteDeviceDefect(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/basedata/defect_management', { data: payload })
    )
    return Callback(err, res)
  }
  // 设备缺陷导入
  static async getDeviceDefectTemplate() {
    const [err, res] = await To(wizStandardInstance.get('/api/defect_management/template'))
    return Callback(err, res)
  }
  // 导入设备缺陷
  static async uploadDeviceDefect(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/defect_management/import', payload.formData)
    )
    return Callback(err, res)
  }
  // 导出设备缺陷
  static async exportDeviceDefect(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/defect_management/export', payload))
    return Callback(err, res)
  }
  // 查询文档清单列表
  static async getDocumentFileList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/document-file-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 删除设备缺陷
  static async deleteDocumentFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/Document/document-file', { data: payload })
    )
    return Callback(err, res)
  }
  // 获取位号上下级树
  static async getTagTreeList(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/tag/get-tag-tree-list', payload))
    return Callback(err, res)
  }
  // 获取位号上下级树下级数据
  static async getTagTreeListChildren(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/tag/get-tag-children', payload))
    return Callback(err, res)
  }
  // 批量生成二维码
  static async generateBulkQrcodes(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/generate-bulk-qrcodes', payload)
    )
    return Callback(err, res)
  }
  // 查询文档清单列表
  static async getRedisProgress(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Common/redis-progress/${payload}`)
    )
    return Callback(err, res)
  }
  // 对象属性完整性报表导出
  static async getLoacleFile(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Common/get-loacle-file/${payload}`, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 获取数据对象树
  static async getDataObjectTree(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/directory_expansion_v3', payload)
    )
    return Callback(err, res)
  }
}
